import React from 'react'
import { ToastContainer, Toast, Row, Col, Button } from 'react-bootstrap'


export default function ToastConfirmation( { showToaster, setShowToaster, message } ) {

  const delayTime = 2000;

  return (
    <>
    {/*<Row>
    <Col xs={12}>
    */}
        <Toast style={{width: '100%'}} onClose={() => setShowToaster(false)} show={showToaster} autohide className={'save-toast'} delay={ delayTime }>
          <Toast.Header>
            <strong className="me-auto">{ message }</strong>
            <small></small>
          </Toast.Header>
          {/*<Toast.Body>{ message }</Toast.Body>*/}
        </Toast>
      {/*
        </Col>
      </Row>
    */}
    </>
  )
}
